module.exports = __webpack_public_path__ + "img/jack.78c8a9c7.jpg";